import React from 'react';
import ReactPaginate from 'react-paginate';


function CommonPagination({ handlePageClick, forcePage, pageCount, nextPage }) {
    return (
        <div className='cstm_pagination'>
            <style>{CMN_PAGINATION_CSS}</style>
            <ReactPaginate
                forcePage={forcePage}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                breakLabel="..."
                nextLabel={"Next >"}
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
            />
        </div>
    )
}

// Self-contained light-theme styling shipped with the component (same approach
// CommonModal uses), so the pager looks identical on every page without each
// surface having to re-skin it. Rendered as an in-body <style>, so it wins over
// the legacy dark default in index.css by source order; the active-state rule is
// one notch more specific to beat index.css's own active rule. Any page that
// still adds its own scoped .cstm_pagination override (Risk Portal, TPCRM, main
// dashboard, modals) is more specific again and continues to win harmlessly —
// it produces the same look these tokens already give.
const CMN_PAGINATION_CSS = `
.cstm_pagination { display: flex; justify-content: flex-end; }
.cstm_pagination .pagination {
    display: flex;
    align-items: center;
    gap: var(--space-sm, 6px);
    list-style: none;
    margin: 0;
    padding: 0;
}
.cstm_pagination .page-item .page-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 32px;
    padding: 0 10px;
    background: var(--color-surface, #ffffff);
    border: 1px solid var(--color-border-strong, #cbd5e1);
    border-radius: var(--radius-sm, 6px);
    color: var(--color-text-secondary, #475569);
    font-family: var(--font-family, inherit);
    font-size: var(--fs-body, 14px);
    cursor: pointer;
    transition: background .15s ease, border-color .15s ease, color .15s ease;
}
.cstm_pagination .page-item .page-link:hover {
    background: var(--color-surface-hover, #f1f5f9);
    color: var(--color-text-primary, #0f172a);
}
.cstm_pagination .page-item.active .page-link {
    background: var(--gradient-brand, #1e3c65);
    border-color: transparent;
    color: var(--color-text-inverse, #ffffff);
}
.cstm_pagination .page-item.disabled .page-link {
    opacity: 0.5;
    cursor: not-allowed;
}
`;

export default CommonPagination;
